import { useMutation } from "@tanstack/react-query";
import { deactivateAtreemo } from "../../api/bAtreemoApi";

export const useDeactivateAtreemo = () => {
  return useMutation({
    mutationKey: ["deactivate-atreemo"],
    mutationFn: (data) => deactivateAtreemo(data),
    onError: (error) => {
      console.error("Atreemo deactivation error:", error.response || error);
    },
  });
};
